import React, { memo, useState } from "react";
import ReactModal from "react-modal";
import {
    Button,
    Col,
    Form,
    FormControl,
    InputGroup,
    Modal,
} from "react-bootstrap";
import { webhookType, webhookTypeName } from "../../../../constants";
import { generateWebhookSecret } from "../../../../api";

const Secret = ({ organizationId, type }) => {
    const [secret, setSecret] = useState("****************");
    const [visibility, setVisibility] = useState(false);
    const [isCopied, setIsCopied] = useState(false);
    const [error, setError] = useState(undefined);
    const [showModal, setShowModal] = useState(false);

    const generateSecret = () => {
        generateWebhookSecret({ organizationId, type })
            .then((res) => {
                if (res.status) {
                    setSecret(res.secret);
                    setVisibility(true);
                } else {
                    setError(res.message);
                }
            })
            .catch((err) => {
                setError(res.message);
            });
        setShowModal(false);
    };

    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(secret)
            .then(() => {
                setIsCopied(true);
            })
            .catch((err) => {
                console.error("Failed to copy text: ", err);
            });
    };

    const handleModal = () => {
        setShowModal(!showModal);
    };

    return (
        <>
            <Form.Group
                as={Col}
                xs={2}
                lg={2}
                className="px-3 modal-pd rev-tier"
            >
                <Form.Label>Secret</Form.Label>
            </Form.Group>
            <Col xs={10} lg={10}>
                <Form.Group
                    as={Col}
                    xs={8}
                    lg={8}
                    className="px-3 modal-pd rev-tier"
                >
                    <Form.Control
                        xs={10}
                        lg={10}
                        type="text"
                        name="secret"
                        value={secret}
                        disabled
                    />
                    {visibility && (
                        <Button
                            xs={2}
                            lg={2}
                            variant="outline-secondary"
                            onClick={copyToClipboard}
                        >
                            {isCopied ? "Copied" : "Copy"}
                        </Button>
                    )}
                </Form.Group>
                <Form.Group
                    as={Col}
                    xs={2}
                    lg={2}
                    className="px-3 modal-pd rev-tier"
                >
                    <Button variant="primary" onClick={handleModal}>
                        Generate
                    </Button>
                </Form.Group>
                {error !== undefined && (
                    <div>
                        <Form.Group as={Col} xs={2} lg={2}></Form.Group>
                        <Form.Control.Feedback
                            type="invalid"
                            as={Col}
                            xs={10}
                            lg={10}
                        >
                            {error}
                        </Form.Control.Feedback>
                    </div>
                )}
            </Col>
            <ReactModal isOpen={showModal} onHide={handleModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Warning</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure? Generating a new secret will render the
                    previous one invalid for future requests.
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModal}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={generateSecret}>
                        Generate
                    </Button>
                </Modal.Footer>
            </ReactModal>
        </>
    );
};

Secret.defaultProps = {};

export default memo(Secret);
